/**
 * Skeleton — a pulsing placeholder block on the `raised` token.
 *
 * Used by the `Sidebar` primitive's `SidebarMenuSkeleton`; reusable for any
 * loading placeholder.
 */
import * as React from "react";
import { cn } from "../lib/cn.js";

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-raised", className)} {...props} />;
}
